// extracted by mini-css-extract-plugin
export default {"page":"U7-z","cartModal":"V7-z","checkout":"W7-z","placeholder":"X7-z","account":"Y7-z"};